import { IApplicationState } from '../../../../../../types/types';
import { ICardCommentsState } from '../store/reducers/types';

export const getCardPanelComments = (
    state: IApplicationState
): ICardCommentsState => {
    return state.comments;
}
